var map = {
	"./10-benefits-choosing-self-service-laundry.tsx": [
		8920,
		920
	],
	"./Iis-it-cheaper.tsx": [
		724,
		724
	],
	"./how-to-keep-your-clothes-smelling-fresh-all-the-time.tsx": [
		6622,
		622
	],
	"./the-hidden-hygiene-risks-of-home-laundry.tsx": [
		1099,
		99
	],
	"./why-a-local-laundromat-in-hamilton-east-makes-all-the-difference.tsx": [
		4509,
		509
	],
	"./why-easy-no-hassle-laundry-services-boost-customer-satisfaction.tsx": [
		3667,
		667
	],
	"./why-increasing-numbers-of-people-prefer-laundromats-a-clever-method-for-managing-laundry-in-hamilton.tsx": [
		3093,
		93
	],
	"./why-more-hamilton-locals-are-ditching-home-washing-for-laundromats.tsx": [
		8913,
		913
	],
	"./why-self-service-laundries-are-a-smart-choice-for-busy-bachelors.tsx": [
		7812,
		812
	],
	"./why-self-service-laundromats-are-the-future-of-laundry-convenience.tsx": [
		9937,
		937
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4469;
module.exports = webpackAsyncContext;